import React from 'react'
import {
  Title,
  SpacingVertical,
  TITLE_VARIANT_M,
  SPACING_16,
  Flex,
  FlexItem
} from 'mailup-web-components'
import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'
import styled from '@emotion/styled'

const StyledIcon = styled.img`
  width: 24px;
  height: 24px;
  padding-right: 8px;
`

export const ParagraphRowHeader = ({ title, icon, spacingTop }) => {
  const intl = useIntl()

  return (
    <>
      {spacingTop}
      <Flex alignItems='center'>
        <FlexItem>
          <StyledIcon src={icon} />
        </FlexItem>
        <FlexItem>
          <Title variant={TITLE_VARIANT_M}>
            {intl.formatMessage({ id: title })}
          </Title>
        </FlexItem>
      </Flex>

      <SpacingVertical variant={SPACING_16} />
    </>
  )
}

ParagraphRowHeader.propTypes = {
  title: PropTypes.func,
  icon: PropTypes.func,
  spacingTop: PropTypes.object
}
